// widgets/player/IPlayerWidget.ts
/** Режимы, оставляем как строки для совместимости */
var PlayerMode;
(function (PlayerMode) {
    PlayerMode["off"] = "off";
    PlayerMode["preview"] = "preview";
    PlayerMode["newFootage"] = "new-footage";
    PlayerMode["editFootage"] = "edit-footage";
    PlayerMode["newScene"] = "new-scene";
    PlayerMode["playWebFootage"] = "play-web-footage";
    PlayerMode["audio"] = "audio";
})(PlayerMode || (PlayerMode = {}));

export { PlayerMode };
